import {
  Box,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import CustomInput from "./customComponent/CustomInput";
import CustomButton from "./customComponent/CustomButton";
import {
  createProject,
  createProjectByDataset,
} from "../services/projectService";
import { IAddProject, IAddProjectByDataset } from "@types";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getFile } from "common-lib";
import { initialProjectData } from "../pages/ProjectPage";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500px",
  height: "fit-content",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "var(--secondary-bg-color)",
  boxShadow: 24,
  borderRadius: 1,
  p: 1,
};

interface ProjectCreateModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  item: DatasetItem;
}

// 데이터셋 파일 객체값 format
const flattenTransformedData = (transformedData: any) => {
  let flattenedData: any = [];

  Object.keys(transformedData).forEach((label) => {
    transformedData[label].forEach((item: any) => {
      flattenedData.push({ ...item, label });
    });
  });

  return flattenedData;
};

function transformData(data: any) {
  let transformedData: any = {
    unlabeled: [],
  };

  if (Array.isArray(data.all)) {
    data.all.forEach((item: any) => {
      const id = item[0];
      const path = item[1];
      const label = item[2];

      if (!transformedData[label]) {
        transformedData[label] = [];
      }

      transformedData[label].push({ id, path });
    });
  }

  if (Array.isArray(data.unlabeled)) {
    data.unlabeled.forEach((item: any) => {
      const id = item[0];
      const path = item[1];
      transformedData["unlabeled"].push({ id, path });
    });
  }

  return transformedData;
}

export default function ProjectCreateModal({
  open,
  setOpen,
  item,
}: ProjectCreateModalProps) {
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const [materialName, setMaterialName] = useState<string>("");
  const [images, setImages] = useState<ImageItem[]>([]);
  const [step, setStep] = useState("분류");
  useEffect(() => {
    console.log(item);
    const fetchDatasetImages = async () => {
      // 데이터셋의 이미지 조회
      try {
        const response = await getFile(item.path);
        console.log(response);
        setImages(flattenTransformedData(transformData(response.data)));
      } catch (error) {
        console.error(error);
      }
    };
    fetchDatasetImages();
  }, []);

  const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const step = e.target.value;
    setStep(step);
  };

  const handleSubmit = async () => {
    // const step = item.fileData.type.includes("unsup") ? "분류" : "분석";
    const projectData: IAddProject = {
      project_name: name,
      dataSet_id: item.id,
      file_path: item.path,
      step: step,
      material_name: materialName,
      // class_list: ["A","B","C","D"],
      inspModel_id: 611, // 임시로 넣어둠
      config: {
        ...initialProjectData.config,
        // keyConfig:
        //   step === "분석"
        //     ? Array.from({ length: labelCount }, (_, i) => (i + 1).toString())
        //     : initialProjectData.config.keyConfig,
      },
      create_at: new Date(new Date().getTime() + 9 * 60 * 60 * 1000),
    };

    console.log("projectData", item, projectData);
    try {
      // const response = await createProjectByDataset(projectData);
      const response = await createProject(projectData);
      const id = response.project_id;
      if (step === "분류") {
        navigate(`/main/project/${id}`);
      } else {
        navigate(`/main/project/${id}/analysis/step=1`);
      }
      toast.success(t("SuccessSaveMsg"));
    } catch (error) {
      console.error("프로젝트 생성 오류", error);
      const errorMessage = (error as Error).message || t("ErrorOccurred");
      toast.warning(errorMessage);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Box
        sx={{
          ...ModalStyle,
          bgcolor: "var(--dk-surface, #fff)",
          borderRadius: 3,
          p: 3,
          width: 450,
        }}
      >
        {/* 제목 */}
        <Typography variant="h6" fontWeight={600} mb={2}>
          {" "}
          프로젝트 생성
        </Typography>

        <Box display="flex" flexDirection="column" gap={3}>
          {/* 프로젝트 타입 */}
          <Box>
            <Typography variant="body2" color="text.secondary" mb={1}>
              프로젝트 타입
            </Typography>

            <RadioGroup row value={step} onChange={handleTypeChange}>
              <FormControlLabel value="분류" control={<Radio />} label="분류" />
              <FormControlLabel value="분석" control={<Radio />} label="분석" />
              <FormControlLabel value="검사" control={<Radio />} label="검사" />
            </RadioGroup>
          </Box>

          {/* 프로젝트 정보 */}
          <Box
            sx={{
              border: "1px solid var(--dk-border, #eee)",
              borderRadius: 2,
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography fontWeight={600}>프로젝트 정보</Typography>

            <CustomInput
              required={true}
              subTitle={t("ProjectName")}
              value={name}
              setValue={setName}
              width="100%"
            />

            <CustomInput
              required={false}
              subTitle={t("MaterialName")}
              value={materialName}
              setValue={setMaterialName}
              width="100%"
            />
          </Box>

          {/* 데이터셋 정보 */}
          <Box
            sx={{
              border: "1px solid var(--dk-border, #eee)",
              borderRadius: 2,
              p: 2,
              bgcolor: "var(--dk-surface-2, #fafafa)",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography fontWeight={600}>데이터셋 정보</Typography>

            <Box>
              <Typography variant="body2" color="text.secondary">
                데이터셋 이름
              </Typography>
              <Typography>{item.name}</Typography>
            </Box>

            <Box>
              <Typography variant="body2" color="text.secondary">
                설명
              </Typography>
              <Typography>{item.description || "-"}</Typography>
            </Box>
          </Box>

          {/* 버튼 */}
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <CustomButton
              text={t("Save")}
              variant="contained"
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
